import React from 'react';

function HouseholdManagement() {
  return (
    <div className="container fade-in">
      <div className="page-header">
        <div>
          <h1>Household Management</h1>
          <p>Manage Family Nest members, roles, and settings</p>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="empty-state">
            <div className="empty-state-icon">🏠</div>
            <div className="empty-state-text">Household management coming soon</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HouseholdManagement;
